import React, { FC } from "react";

import { useSite } from "_foundation/hooks/useSite";
import { useAppSelector } from "_redux/hooks";
import { selectTopCategories } from "_redux/selectors/catalog";
import SideBarAccordions from "./SideBarAccordions";

interface SideBarCategoriesProps {
  closeSideBar: () => void;
}

const SideBarCategories: FC<SideBarCategoriesProps> = ({ closeSideBar }) => {
  const categoryViewTop = useAppSelector(selectTopCategories);
  const { currentSite } = useSite();

  if (!categoryViewTop || !currentSite?.storeID) {
    return null;
  }

  return (
    <SideBarAccordions
      categories={categoryViewTop}
      closeSideBar={closeSideBar}
      navigationLevels={currentSite.storeCfg.efood.navigationLevels}
    />
  );
};

export default SideBarCategories;
